<style>
    .cdk-overlay-container {
        z-index: 2000;
    }

    svg:focus {
        outline: none !important;
    }

    button:focus {
        outline: none !important;
    }

    .VPrint {
        display: none !important;
    }
</style>

<div class="container" id="VoucherPrint"
    style="height: 100%; margin: 0px; padding: 0px; width: 100%;overflow-x:hidden;overflow-y:hidden;font-family: calibri !important;">
    <div style="width: 100%;">
        <!--Header-->
        <div class="row fontfam" style="margin: 0px;">
            <div class="col-md-12" style="text-align: center;margin-top: 20px;">
                <span style="font-size: 20px">{{AgencyName}}</span><br>
                <span style="font-size: 13px;">{{City ? City + ',' : ''}} {{State}}</span><br>
            </div>
            <div class="col-md-12" style="text-align: center;margin-top: 20px;">
                <span style="font-size: 18px; font-weight: bold;">{{data.voucherType}}</span><br>
            </div>
        </div>

        <!--Body-->
        <div class="modal-body" style="margin: 0px;">
            <!--Body-->
            <!--Voucher Type + Voucher No-->
            <div class="col-md-12 col-12 col-12 pad0">
                <div class="row fontfam">
                    <!--Voucher No-->
                    <div class="col-md-6" style="margin-top: 5px;">
                        <span style="font-weight: bold;font-size: 12px;">Voucher No. : </span><span
                            style="font-weight: bold; font-size: 17px;"> {{data.voucherNO}} </span>
                    </div>
                    <div class="col-md-6" style="margin-top: 5px;text-align: right;">
                        <span style="font-weight: bold;font-size: 12px;">Date : </span><span style="font-size: 12px;">
                            {{data.voucherDate  }} </span>
                    </div>
                </div>
            </div>

            <!--Table + Webview-->
            <div class="col-md-12 col-sm-12 col-xs-12 pad0 webView" style="margin-top: 5px;">
                <table class="table table-bordered tbl">
                    <thead>
                        <tr>
                            <th style="width: 20%;">Ledger</th>
                            <th style="width: 8%;">Credit Amt (₹)</th>
                            <th style="width: 8%;">Debit Amt (₹)</th>
                            <!-- <th style="width: 20%;">Curr. Bal. (₹)</th> -->
                            <!-- <th style="width: 30%;">Notes</th>  -->
                        </tr>
                    </thead>
                    <tbody>
                        <!--List-->
                        <tr *ngFor="let a of dataTbl;">
                            <!--Ledger-->
                            <td>
                                <span>{{a.ledgerName}}</span>
                                <br><span style="color: #777; "> {{a.notes}}</span>
                            </td>
                            <!--Credit-->
                            <td style="text-align: right;">
                                <span>{{a.credit == 0 ? '' : a.credit | lacFormat}}</span>
                            </td>
                            <!--Debit-->
                            <td style="text-align: right;">
                                <span>{{a.debit == 0 ? '' : a.debit | lacFormat}}</span>
                            </td>
                            <!--Curr. Bal-->
                            <!-- <td style="text-align: right;">
                                <span>{{a.curBal | lacFormat}} {{a.curBalType}}</span>
                            </td> -->
                            <!--Notes-->
                            <!-- <td>
                                <span>{{a.notes}}</span>
                            </td> -->
                        </tr>
                        <tr>
                            <td style="font-weight: bold;">
                                <span>Total</span>
                            </td>
                            <td style="text-align: right;">
                                <span>{{CreditTotal | lacFormat}}</span>
                            </td>
                            <td style="text-align: right;">
                                <span>{{DebitTotal | lacFormat}}</span>
                            </td>
                            <!-- <td style="text-align: right;">
                                <span></span>
                            </td>-->
                            <!-- <td style="text-align: right;">
                                <span></span>
                            </td>  -->
                        </tr>
                    </tbody>
                </table>
            </div>

            <div class="col-md-12 col-sm-12 col-xs-12 pad0 webView fontfam" style="margin-top: 10px;" *ngIf="data.details">
                <div class="col-md-6" style="font-weight: bold;display: inline-block;padding: 0px;font-size: 12px;">
                    Note : <span style="color: #333; font-weight: 100"> {{data.details}}</span>
                </div>
            </div>

            <div class="col-md-12 col-sm-12 col-xs-12 pad0 webView fontfam" style="margin-top: 10px;">
                <div class="col-md-6" style="font-weight: bold;display: inline-block;padding: 0px;font-size: 12px;">
                    {{vuchrHistoryID != 0 ? "Updated by" : "Entered by"}}
                </div>
            </div>

            <div class="col-md-12 col-sm-12 col-xs-12 pad0 webView fontfam">
                <div class="col-md-6" style="display: inline-block;padding: 0px;font-size: 12px;">
                    {{data.EnteredByName}}
                </div>
            </div>
            <div class="col-md-12 col-sm-12 col-xs-12 pad0 webView fontfam">
                <div class="col-md-6" style="display: inline-block;padding: 0px;font-size: 12px;">
                    {{data.createdDate }}
                </div>
            </div>
        </div>
    </div>
</div>
